import { FC } from 'react';
import theme from '../../../theme';
import Icon from '../Icon';

const ErrorIcon: FC<{ size?: number }> = ({ size = 24 }) => (
  <Icon name="error" size={size} color={theme.colors.general.error} />
);

export default ErrorIcon;
